// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular.json`.


export const environment = {
	env: "Development",
    registerServiceWorker: false,
	clientId: "b10d6363-35b6-4138-9726-e625f4d74eab", //ToDo: Once a new envioronment is created, update the clientId
	authority: "https://login.microsoftonline.com/6e57fc1a-413e-4050-91da-7d2dc8543e3c/",
	APPLICATIONINSIGHTS_InstrumentationKey: "859dc977-cf43-4ba6-84fd-4528ea1f70e4", // Todo: we need to get from config and remove
	APPINSIGHTS_TAGS: "Env:Local;Region:Local",
	apiBaseURL:"https://sut-ind-d-01.bdo.com"
};
